import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import BottomNav from "@/components/BottomNav";
import BrandMark from "@/components/BrandMark";
import EventCard from "@/components/EventCard";
import { IDS } from "@/constants/testIds";
import { Plus, CalendarClock } from "lucide-react";

export default function EventsList() {
  const navigate = useNavigate();
  const [data, setData] = useState({ upcoming: [], past: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/events");
        setData(data);
      } catch (err) {
        console.error("events list failed", err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="min-h-[100dvh] bg-[#FBF9F6] grain" style={{ paddingBottom: "calc(6rem + env(safe-area-inset-bottom, 0.75rem))" }}>
      <div className="max-w-md mx-auto px-6 pt-12">
        <BrandMark className="mb-4" />
        <div className="flex items-start justify-between mb-2">
          <div>
            <div className="text-[10px] font-[Manrope] font-bold tracking-[0.3em] uppercase text-stone-500">
              Lookbook
            </div>
            <h1 className="font-[Cormorant_Garamond] text-4xl leading-tight tracking-tight text-stone-900">
              Your events
            </h1>
          </div>
          <button
            data-testid={IDS.eventsNewBtn}
            onClick={() => navigate("/events/new")}
            className="h-12 w-12 rounded-full bg-[#6B7A54] text-white flex items-center justify-center shadow-[0_16px_40px_rgba(107, 122, 84,0.25)] active:scale-[0.97] transition-transform"
          >
            <Plus size={20} strokeWidth={1.5} />
          </button>
        </div>
        <p className="text-sm font-[Manrope] text-stone-600 mb-8">
          Plan looks for weddings, festivals & big meetings.
        </p>

        {loading && (
          <div className="text-center py-16 text-xs font-[Manrope] text-stone-400 tracking-[0.3em] uppercase">Loading</div>
        )}

        {!loading && data.upcoming.length === 0 && data.past.length === 0 && (
          <div className="mt-8 text-center">
            <CalendarClock size={40} strokeWidth={1.2} className="mx-auto text-[#6B7A54]/50 mb-4" />
            <p className="font-[Cormorant_Garamond] text-2xl italic text-stone-500 leading-snug">
              Nothing on the calendar.<br />Add a wedding, party or trip.
            </p>
            <button
              onClick={() => navigate("/events/new")}
              className="mt-6 px-6 py-3 rounded-full bg-[#6B7A54] text-white font-[Manrope] text-sm font-medium"
            >
              Plan an event
            </button>
          </div>
        )}

        {data.upcoming.length > 0 && (
          <section className="mt-2">
            <div className="text-[10px] font-[Manrope] font-bold tracking-[0.3em] uppercase text-stone-500 mb-3">
              Upcoming
            </div>
            <div className="flex flex-col gap-3">
              {data.upcoming.map((e) => <EventCard key={e.event_id} event={e} />)}
            </div>
          </section>
        )}

        {data.past.length > 0 && (
          <section className="mt-8">
            <div className="text-[10px] font-[Manrope] font-bold tracking-[0.3em] uppercase text-stone-500 mb-3">
              Past
            </div>
            <div className="flex flex-col gap-3 opacity-70">
              {data.past.map((e) => <EventCard key={e.event_id} event={e} compact />)}
            </div>
          </section>
        )}
      </div>
      <BottomNav />
    </div>
  );
}
